import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import api from '../utils/httpClient';

interface User {
  ID: string;
  FirstName: string;
  LastName: string;
  Email: string;
}

export const getUsersWithClassroomAccess = createAsyncThunk(
  'classSessionUser/getUsersWithClassroomAccess',
  async (accountId: string) => {
    const response = await api.get(
      `/user?accountId=${accountId}&enableClassroom=true`
    );

    return response.data as Array<User>;
  }
);

export interface InitialState {
  saving: boolean;
  success: boolean;
  error: string;
  data: Array<User>;
}

const initialState: InitialState = {
  saving: false,
  error: '',
  success: false,
  data: [],
};

const classSessionUserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getUsersWithClassroomAccess.pending, (state) => {
      state.saving = true;
      state.success = false;
      state.error = '';
    });
    builder.addCase(
      getUsersWithClassroomAccess.fulfilled,
      (state, action: PayloadAction<Array<User>>) => {
        state.saving = false;
        state.success = true;
        state.error = '';
        state.data = action.payload;
      }
    );
    builder.addCase(getUsersWithClassroomAccess.rejected, (state, action) => {
      console.error(action.error);
      state.saving = false;
      state.success = false;
      state.error = 'Unable to get users with classroom access';
    });
  },
});

export const { reset } = classSessionUserSlice.actions;
export default classSessionUserSlice;
